export default "__VITE_ASSET__DpXAsiUu__"